import { useEffect, useMemo, useRef, useState } from "react";
import * as Icons from "react-icons/bs";
import { TDocumentTree } from "../../types";
import { DocumentTree } from "../side-bar/DocumentTree";
import "../../scss/panels.scss";
import { SideBarTabs, useDocuments } from "../../contexts/DekstopContext";

export enum Target {
  CLOUD = "cloud",
  MOBILE = "mobile",
  DESKTOP_VINTAGE = "desktop vintage",
  DESKTOP_MODERN = "desktop modern",
}

export const TabbedPanel = ({
  data,
}: {
  data: { name: SideBarTabs; label: string; data: TDocumentTree; fetcher?: (...props: any) => any }[];
}) => {
  const { activeTab, setActiveTab } = useDocuments();

  //   const [activeTab, setActiveTab] = useState(data && data.length ? data[0].name : null);

  const tabsHeaderRef = useRef<HTMLDivElement>(null);

  const scrollLeft = (e: React.MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
    if (tabsHeaderRef.current) {
      tabsHeaderRef.current.scrollBy({ left: -100, behavior: "smooth" });
    }
  };

  const scrollRight = (e: React.MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
    if (tabsHeaderRef.current) {
      tabsHeaderRef.current.scrollBy({ left: 100, behavior: "smooth" });
    }
  };

  const content = useMemo(() => {
    if (!data || data.length === 0 || !activeTab) return null;
    const relevantTab = data.find((t) => t.name === activeTab);
    if (!relevantTab) return null;
    return {
      data: relevantTab.data,
      fetcher: relevantTab.fetcher,
    };
  }, [activeTab, data]);

  return (
    <div className={`lintui-panel`}>
      <div className="lintui-panel-header-container">
        <div className="lintui-panel-header" ref={tabsHeaderRef}>
          {data.map((entry, idx) => (
            <div
              key={`${idx}-${entry.name}-${entry.data.length}`}
              className={`tab-button ${activeTab === entry.name ? "active" : ""}`}
              onClick={() => setActiveTab(entry.name)}
              onMouseDown={(e) => e.preventDefault()}
            >
              {entry.label}
            </div>
          ))}
          {/* <div className={`lintui-panel-tabs-entry-filler`}></div> */}
        </div>
        <div className="scroll-controls">
          <div className="scroll-button" onClick={scrollLeft} onMouseDown={(e) => e.preventDefault()}>
            <Icons.BsArrowLeftSquare />
          </div>
          <div className="scroll-button" onClick={scrollRight} onMouseDown={(e) => e.preventDefault()}>
            <Icons.BsArrowRightSquare />
          </div>
        </div>
      </div>
      <div className={`lintui-panel-content`}>
        <div className={`lintui-panel-content-inner`}>
          {content ? <DocumentTree key={activeTab} tree={content.data} fetcher={content.fetcher} /> : null}
        </div>
      </div>
    </div>
  );
};
